<div class="music-container absolute inset-0 w-full h-full">
    <canvas #audioCanvas class="w-full h-full"></canvas>
</div>